export const nav = {
    permissao: 'hdocs.pessoas:ver',
    section: 'Documentos',
    title: 'GerarPorPessoa',
    icon: 'person_search',
    route: '/pessoas',
    // Entre Emissao (1) e Documentos (2): e a forma de emitir para varias pessoas de uma vez.
    sequence: 1.5,
};

// "/pessoas/geracoes" vem ANTES de "/pessoas/geracoes/:id": o router casa na ordem.
export default [
    {
        path: '/pessoas',
        name: 'pessoas',
        component: () => import('./pages/GerarPorPessoaPage.vue'),
        meta: { requiresAuth: true, permissao: 'hdocs.pessoas:ver' },
    },
    {
        path: '/pessoas/geracoes',
        name: 'pessoas-geracoes',
        component: () => import('./pages/GeracoesPage.vue'),
        meta: { requiresAuth: true, permissao: 'hdocs.pessoas:ver' },
    },
    {
        path: '/pessoas/geracoes/:id',
        name: 'pessoas-geracao',
        component: () => import('./pages/GeracaoPage.vue'),
        props: true,
        meta: { requiresAuth: true, permissao: 'hdocs.pessoas:ver' },
    },
];
